<template>
  <div class="header">
    <div class="logo"></div>
    <div class="nav">
      <div @mouseover="hoverIndex = 0" @mouseout="hoverIndex = -1" :class="{'nav_hover':0==hoverIndex || 0 == navIndex}" @click="gotoHome">首页</div>
      <div @mouseover="showProductList" @mouseout="hiddenProductList">
        <div :class="{'nav_hover':1==hoverIndex || 1 == navIndex}">语言学习产品</div>
        <div class="product_list" :class="{hidden: isHidden}">
          <p @click="gotoZhishi">InteliClass—智师课堂</p>
          <p @click="gotoOralTrain">大鱼人机口语</p>
          <p @click="gotoShuyuAI">树鱼智能普通话</p>
          <p @click="gotoShowMatch">秀一哈</p>
          <p @click="gotoPhonetics">每日正音</p>
          <p @click="gotoThreeHalf">三点半课堂</p>
        </div>
      </div>
      <div @mouseover="hoverIndex = 2" @mouseout="hoverIndex = -1" :class="{'nav_hover':2==hoverIndex || 2 == navIndex}" @click="gotoScenarios">解决方案及服务</div>
      <div @mouseover="hoverIndex = 3" @mouseout="hoverIndex = -1" :class="{'nav_hover':3==hoverIndex || 3 == navIndex}" @click="gotoDigital">数码故事</div>
      <div @mouseover="hoverIndex = 4" @mouseout="hoverIndex = -1" :class="{'nav_hover':4==hoverIndex || 4 == navIndex}" @click="gotoAbout">关于公司</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      isHidden: true,
      isHover: false,
      hoverIndex: -1,
      navIndex: 0
    }
  },
  created: function () {
    let pathname = window.location.pathname
    if (pathname === '/') {
      this.navIndex = 0
    } else if (pathname.indexOf('products') > -1) {
      this.navIndex = 1
    } else if (pathname === '/scenarios') {
      this.navIndex = 2
    } else if (pathname === '/digital') {
      this.navIndex = 3
    } else if (pathname === '/about') {
      this.navIndex = 4
    }
  },
  methods: {
    showProductList: function () {
      this.isHidden = false
      this.hoverIndex = 1
    },
    hiddenProductList: function () {
      this.isHidden = true
      this.hoverIndex = -1
    },
    gotoHome () {
      this.navIndex = 0
      this.$router.push('/')
    },
    // 不需要这个页面了
    // gotoProducts () {
    //   this.navIndex = 1
    //   this.$router.push('/products')
    // },
    gotoScenarios () {
      this.navIndex = 2
      this.$router.push('/scenarios')
    },
    gotoDigital () {
      this.navIndex = 3
      this.$router.push('/digital')
    },
    gotoAbout () {
      this.navIndex = 4
      this.$router.push('/about')
    },
    gotoOralTrain () {
      this.navIndex = 1
      this.$router.push('/products/oralTrain')
    },
    gotoZhishi () {
      this.navIndex = 1
      this.$router.push('/products/zhishi')
    },
    gotoShuyuAI () {
      this.navIndex = 1
      this.$router.push('/products/shuyuAI')
    },
    gotoPhonetics () {
      this.navIndex = 1
      this.$router.push('/products/phonetics')
    },
    gotoShowMatch () {
      this.navIndex = 1
      this.$router.push('/products/showMatch')
    },
    gotoThreeHalf () {
      window.location.href = 'https://vr.flyingcloud.com.cn:9443/login.html'
    }
  }
}
</script>

<style scoped>
  .hidden{
    visibility: hidden;
  }
  .header{
    display: flex;
    height: 4.8vw;
    width: 100vw;
    border-bottom: 1px #707070 solid;
  }
  .logo{
    background-image: url("../assets/images/logo_new.jpg");
    background-size: 100% 100%;
    width: 20vw;
    height: 2.4vw;
    margin: 1vw 38vw 0 4vw;
  }
  .nav{
    display: flex;
    font-size: 1vw;
    width: 40vw;
    justify-content: space-between;
    color: #707070;
    height: 4vw;
    line-height: 4.8vw;
  }
  .nav_hover{
    color: #23B8FC;
    font-weight: 600;
    cursor:pointer
  }
  .nav_hover:after{
    content: "";
    display: block;
    width: 1vw;
    border-width: 0.2vw;
    border-radius: 50vw;
    position: relative;
    border-style: solid;
    border-color: #5FCAFF;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 0;
    margin: -1.2vw auto 0;
    background: #5FCAFF;
  }
  .product_list{
    position: absolute;
    z-index: 1;
    text-align: center;
    font-size: 0.8vw;
    line-height: 1.3vw;
    background: #5FCAFF;;
    width: 10vw;
    margin-left: -2vw;
    margin-top: -0.5vw;
    border-radius: 10%;
    color: white;
    padding-top: 1.2vw;
    font-weight: 600;
    cursor:pointer
  }
  .product_list:before{
    content: "";
    display: block;
    border-width: 0.8vw;
    position: absolute;
    left: 4.2vw;
    top: -1.1vw;
    border-style: solid dashed dashed;
    border-color: transparent transparent #5FCAFF;
    font-size: 4vw;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue